import React from 'react';
import { Box } from '@mui/material';
import PositionSkills from './PositionSkills';

const TalentInsights = ({ form }) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <PositionSkills form={form} />
        </Box>
    );
};

export default TalentInsights;
